import { IFilter } from '../../types/filters';
import { ApartmentsContainer } from '../../containers/advancedFilters/ApartmentsContainer';

export const apartments: IFilter = {
  component: ApartmentsContainer,
};
